var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card p-05" }, [
    _c("div", { staticClass: "card-container" }, [
      _c("div", { staticClass: "d-inline-flex p-2" }, [
        _c("div", [
          _c("div", [_c("h3", [_vm._v(_vm._s(_vm.plan.title))])]),
          _vm._v(" "),
          _vm.plan.type === "company"
            ? _c("div", [
                _c("p", [
                  _c("i", { staticClass: "feather icon-users" }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.plan.num_individuals === 0
                          ? "Unlimited"
                          : _vm.plan.num_individuals
                      ) +
                      " Users"
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "font-weight-bolder font-size-medium" },
            [
              _vm.plan.price === 0
                ? _c("div", [
                    _vm._v(
                      "\n                        Free\n                    "
                    ),
                  ])
                : [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm._f("currency")(_vm.plan.price, _vm.site_tax)
                        ) +
                        " / " +
                        _vm._s(_vm.plan.interval) +
                        "\n                    "
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "mt-05",
            domProps: { innerHTML: _vm._s(_vm.plan.description) },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.plan.plan_features.length > 0
      ? _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("plan-features", {
              attrs: { plan_features: _vm.plan.plan_features },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer border-0 bg-white mt-auto" }, [
      _vm.selected_plan_id === _vm.plan.stripe_plan_id
        ? _c(
            "button",
            {
              staticClass: "btn btn-success btn-block",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.cancelPlan.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n            Selected\n        ")]
          )
        : _c(
            "button",
            {
              staticClass: "btn btn-primary btn-block",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.selectPlan.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n            Select this plan\n        ")]
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }